import {
  Box, Container, Skeleton, Typography,
} from '@mui/material'
import CardWithSpace from '../../../components/Cards/CardWithSpace'
import TitleWithIcon from '../../../components/Cards/helpers/TitleWithIcon'
import { styles } from './InboxCardList'
import { createArrayOfNumbers } from '../../../utils/helpers'

const InboxCardListSkeleton = ({ size = 1 }) => (
  <Container maxWidth={false} sx={customStyles.container} data-testid="inboxListSkeleton">
    {[createArrayOfNumbers(size)].map((item) => (
      <CardWithSpace
        flex
        key={item}
        color="#1717251c"
        customStyles={{ ...styles.card, backgroundColor: 'transparent' }}
      >
        <Box sx={styles.cardDataContainer}>
          <Box sx={styles.cardsContainer}>
            <Box sx={styles.cardHeader}>
              <TitleWithIcon
                title={(
                  <Box sx={customStyles.cardHeader}>
                    <Skeleton variant="circle" width={15} height={15} sx={{ display: { xs: 'none', sm: 'flex' } }} />
                    <Skeleton variant="text" width={250} height={20} />
                  </Box>
                 )}
                customStyle={styles.stackFlex}
              />
            </Box>
            <Box sx={customStyles.cardTitle}>
              <Skeleton variant="text" width={150} height={20} />
            </Box>
            <Box sx={styles.cardInfoContainer}>
              <Box sx={styles.rowFlex}>
                <TitleWithIcon
                  title={(
                    <Box sx={customStyles.requestedOnContainer}>
                      <Skeleton variant="circle" width={15} height={15} />
                      <Typography variant="body1" sx={styles.requestedOnDate}>
                        <Skeleton variant="text" width={150} height={20} />
                      </Typography>
                    </Box>
                 )}
                  customStyle={styles.iconWithText}
                />
              </Box>
              <Box sx={styles.rowFlex}>
                <TitleWithIcon
                  title={(
                    <Box sx={customStyles.requestedOnContainer}>
                      <Skeleton variant="circle" width={15} height={15} />
                      <Typography variant="body1" sx={styles.requestedOnDate}>
                        <Skeleton variant="text" width={180} height={20} />
                      </Typography>
                    </Box>
                 )}
                  customStyle={styles.iconWithText}
                />
              </Box>
            </Box>
          </Box>
          <Box sx={customStyles.cardActionContainer}>
            <Box sx={customStyles.cardAction}>
              <Skeleton variant="circle" sx={{ width: { xs: '20px', sm: '40px' }, height: { xs: '20px', sm: '40px' } }} />
              <Skeleton variant="text" width={40} height={20} sx={{ display: { xs: 'flex', sm: 'none' } }} />

            </Box>
            <Box sx={customStyles.cardAction}>

              <Skeleton variant="circle" sx={{ width: { xs: '20px', sm: '40px' }, height: { xs: '20px', sm: '40px' } }} />
              <Skeleton variant="text" width={40} height={20} sx={{ display: { xs: 'flex', sm: 'none' } }} />

            </Box>
          </Box>
        </Box>
      </CardWithSpace>
    ))}
  </Container>
)

const customStyles = {
  cardTitle: {
    marginLeft: { xs: '40px', sm: '50px' },

  },
  cardHeader: {
    display: 'flex',
    marginLeft: { xs: '40px', sm: '5px' },
    gap: '10px',
  },
  requestedOnContainer: {
    display: 'flex',
    marginLeft: { xs: '10px', sm: '12px' },
    gap: '10px',

  },
  cardAction: {
    display: 'flex',
    justifyContent: { xs: 'center', sm: 'flex-end' },
    alignItems: 'center',
    margin: { xs: '5px 0px', sm: '0px' },
    gap: { xs: '10px', sm: '0px' },
    marginRight: { xs: '0px', md: '-30px' },
  },
  cardActionContainer: {
    display: 'flex',
    gap: { xs: '70px' },
    justifyContent: { xs: 'center', sm: 'flex-end' },
  },
  container: {
    marginTop: '0px !important',
  },
}
export default InboxCardListSkeleton
